import React from "react";
import {
  SectionContainer,
  MainTitle,
  SubTitle,
  Description,
  Image,
  DescriptionContent,
  Container,
} from "./styles";
import { RiTerminalBoxFill } from "react-icons/ri";
import image from "../../assets/dev.png";

const DevsSebrae = () => {
  return (
    <SectionContainer>
      <Container>
        <DescriptionContent>
          <SubTitle>
            <RiTerminalBoxFill size={32} color="#0041D9" />
            Desenvolvedores Sebrae
          </SubTitle>
          <MainTitle>Soluções em APIs Na Palma Da Sua Mão</MainTitle>
          <Description>
            Conheça as diversas soluções em API que o Sebrae oferece para seu
            negócio.
          </Description>
        </DescriptionContent>
        <Image alt="imagem" src={image} />
      </Container>
    </SectionContainer>
  );
};

export default DevsSebrae;
